import Hero from "./Components/Hero";
import Footer from "../about/Components/Footer";
import List from "./Components/List";

function Interviews() {
  return (
    <div>
      <Hero />
      <List />
      <Footer />
    </div>
  );
}

export default Interviews;
